import { replaceCurriculum } from 'src/store/curriculum';
import { updateActivityDefinition } from 'src/store/activity';
import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'src/store/index';

export type State = {
  loading: boolean;
};

export const adapter = createEntityAdapter<Model.ClassTopicContents>({
  selectId: (model) => model.id,
});

const { reducer, actions } = createSlice({
  name: 'class_topic_content',
  initialState: adapter.getInitialState<State>({ loading: false }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.ClassTopicContents[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.ClassTopicContents>) {
      adapter.upsertOne(state, action);
    },
    updateCompetition(
      state,
      action: PayloadAction<Model.ClassTopicContentCompetition>,
    ) {
      adapter.updateOne(state, {
        id: action.payload.class_topic_content_id,
        changes: {
          class_topic_content_completion: {
            ...action.payload,
          },
        },
      });
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateActivityDefinition, (state, { payload }) => {
      const existing = state.entities[payload.id];
      if (!existing || existing.class_topic_id !== payload.class_topic_id)
        return;
      adapter.updateOne(state, {
        id: payload.id,
        changes: {
          file_name: payload.file_name,
          description: payload.description,
          ...(payload.activity_config !== undefined
            ? { activity_config: payload.activity_config }
            : {}),
        },
      });
    });
    builder.addCase(replaceCurriculum, (state, action) => {
      const { snapshot, lessonIds } = action.payload;
      adapter.removeMany(
        state,
        Object.values(state.entities)
          .filter((item) => lessonIds.includes(item?.class_topic_id || ''))
          .map((item) => item!.id),
      );
      adapter.upsertMany(
        state,
        snapshot.materials as Model.ClassTopicContents[],
      );
    });
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.class_topic_content,
);

export { reducer };
export default actions;
